import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { ActionType, IAction } from '../../models';

export interface IActionService {
    getAll(): angular.IPromise<IAction[]>;
    getAll(force: boolean): angular.IPromise<IAction[]>;
    getByGuid(guid: string): angular.IPromise<IAction>;
    getByGuid(guid: string, force: boolean): angular.IPromise<IAction>;
    addOne(action: IAction): angular.IPromise<IAction>;
    updateOne(action: IAction): angular.IPromise<IAction>;
    deleteOne(guid: String): angular.IPromise<IAction>;
}

export class ActionService implements IActionService {
    private _controllerUrl = 'action';

    static serviceId = 'actionService';
    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<IAction[]>;
    getAll(force: boolean): angular.IPromise<IAction[]>;
    getAll(force?: boolean): angular.IPromise<IAction[]> {
        if (force) {
            this._requestService.cleanCacheAtV1(this._controllerUrl);
        }
        return this._requestService.getAtV1(this._controllerUrl, undefined, true);
    }

    getByGuid(guid: string): angular.IPromise<IAction>;
    getByGuid(guid: string, force: boolean): angular.IPromise<IAction>;
    getByGuid(guid: string, force?: boolean): angular.IPromise<IAction> {
        const url = `${this._controllerUrl}/${guid}`;
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url, undefined, true);
    }

    addOne(action: IAction): angular.IPromise<IAction> {
        return this._requestService.postAtV1<IAction>(`${this._controllerUrl}/add${ActionType[action.type]}`, action, undefined, true)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    updateOne(action: IAction): angular.IPromise<IAction> {
        return this._requestService.postAtV1<IAction>(`${this._controllerUrl}/update${ActionType[action.type]}`, action, undefined, true)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }

    deleteOne(guid: String): angular.IPromise<IAction> {
        return this._requestService.postAtV1<IAction>(`${this._controllerUrl}/delete/${guid}`, undefined, undefined, true)
            .then(data => {
                this._requestService.cleanCacheAtV1(this._controllerUrl);
                return data;
            });
    }
}